import { render, staticRenderFns } from "./aOrderDetailFee.vue?vue&type=template&id=6a2c9970&scoped=true"
import script from "./aOrderDetailFee.vue?vue&type=script&lang=js"
export * from "./aOrderDetailFee.vue?vue&type=script&lang=js"
import style0 from "./aOrderDetailFee.vue?vue&type=style&index=0&id=6a2c9970&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2c9970",
  null
  
)

export default component.exports